// 세션이 끝났음을 앱에 알린다. axios 계층은 React를 모르므로
// 커스텀 이벤트만 방출하고, SessionWatcher가 이를 받아 캐시 clear +
// 라우팅을 처리한다. axios에 의존하지 않아 jest에서 그대로 테스트된다.
export function clearSessionAndNotify() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.dispatchEvent(new CustomEvent("auth:expired"));
}
